import { useConnectionAnalytics } from 'Modules/softphone/hooks/useConnectionAnalytics';
import { usePoorConnectionTooltip } from 'Modules/softphone/hooks/usePoorConnectionTooltip';
import React from 'react';
import { Icon } from '~/components/shared/Icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/lib/ui/tooltip';
import {
  CONNECTION_STATUS_CONTENT_OFFSET,
  CONNECTION_STATUS_MAP,
} from './index.constants';
import { SoftphoneConnectionStatusProps } from './index.types';

const COMPONENT_ALIAS = 'connection-status';

export const SoftphoneConnectionStatus = ({
  status = 'off',
  testID,
}: SoftphoneConnectionStatusProps): React.ReactElement => {
  const isAutoOpen = usePoorConnectionTooltip(status);
  const { trackConnectionTooltipOpened } = useConnectionAnalytics();

  const componentTestId = testID
    ? `${testID}-${COMPONENT_ALIAS}-${status}`
    : `${COMPONENT_ALIAS}-${status}`;

  return (
    <Tooltip
      open={isAutoOpen ? true : undefined}
      onOpenChange={(open) => {
        if (open && !isAutoOpen) {
          trackConnectionTooltipOpened();
        }
      }}
    >
      <TooltipTrigger asChild>
        <div
          data-testid={`${componentTestId}`}
          className="flex items-center gap-1"
          role="status"
          aria-label={CONNECTION_STATUS_MAP[status].ariaLabel}
          tabIndex={0}
        >
          {status && (
            <Icon
              icon={`connection-${status}`}
              data-testid={`${componentTestId}-icon`}
              aria-hidden="true"
            />
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent
        side="bottom"
        align="end"
        sideOffset={CONNECTION_STATUS_CONTENT_OFFSET}
        className="whitespace-pre-line"
      >
        <p className="text-body leading-[19px] font-normal">
          {CONNECTION_STATUS_MAP[status].tooltip}
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
